// Chooses which parish the round-ups page should preselect. A requested
// parish is only honoured when it can actually receive round-ups.
export function pickInitialRoundupParishId({ requestedId, savedId, parishes }) {
  const list = parishes || []
  const selectable = (p) => p.stripeReady && !p.givingUnavailable
  if (requestedId && list.some((p) => p.id === requestedId && selectable(p))) return requestedId
  if (savedId) return savedId
  const firstReady = list.find(selectable)
  return firstReady ? firstReady.id : ''
}
